export default function ItemLibraryIcon() {
  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    fill="none"
    viewBox="0 0 19 18"
  >
    <g id="Read" clipPath="url(#clip0_710_19601)">
      <path
        id="Vector"
        d="M17.857 1.951h-4.596c-.987 0-1.951.283-2.78.818l-.981.629-.98-.63a5.13 5.13 0 0 0-2.78-.817H1.142a.64.64 0 0 0-.643.643v11.41c0 .356.287.644.643.644h4.596c.987 0 1.951.283 2.78.817l.893.575a.17.17 0 0 0 .086.026.15.15 0 0 0 .086-.026l.892-.575a5.15 5.15 0 0 1 2.785-.817h4.596a.64.64 0 0 0 .643-.643V2.594a.64.64 0 0 0-.643-.643M5.74 13.201H1.946V3.398H5.74c.711 0 1.403.202 2 .586l.98.629.138.09v9.282A6.6 6.6 0 0 0 5.74 13.2m11.315 0H13.26c-1.093 0-2.162.27-3.118.784V4.703l.138-.09.98-.629a3.7 3.7 0 0 1 2-.586h3.793zM7.188 5.97H3.455c-.078 0-.143.068-.143.15v.905c0 .082.065.15.143.15h3.73c.08 0 .143-.068.143-.15V6.12a.145.145 0 0 0-.14-.151m4.482.15v.905c0 .082.064.15.142.15h3.73c.08 0 .143-.068.143-.15V6.12c0-.083-.064-.151-.142-.151h-3.73c-.08 0-.143.068-.143.15M7.188 8.783H3.455c-.078 0-.143.068-.143.15v.904c0 .083.065.15.143.15h3.73c.08 0 .143-.067.143-.15v-.904a.145.145 0 0 0-.14-.15m8.357 0h-3.733c-.078 0-.142.068-.142.15v.904c0 .083.064.15.142.15h3.73c.08 0 .143-.067.143-.15v-.904a.145.145 0 0 0-.14-.15"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_710_19601">
        <path fill="#fff" d="M.5 0h18v18H.5z"></path>
      </clipPath>
    </defs>
  </svg>
}
